module.exports = __webpack_public_path__ + "static/media/logo.213bf5e2.png";